var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw:flex tw:flex-col tw:h-full"},[_c(_setup.MainContentTabs,{attrs:{"tabs":[
            {tab : 'posiciones', nombre: 'Posiciones'},
            {tab : 'compania', nombre: 'Compañía Fiscal'},
            {tab : 'configuracion', nombre: 'Configuración'},
        ],"initialTab":"posiciones","title":"Deportistas"}},[_c('template',{slot:"posiciones"},[_c(_setup.Posiciones)],1),_c('template',{slot:"compania"},[_c(_setup.ConfDeportistasCompania)],1),_c('template',{slot:"configuracion"},[_c(_setup.ConfiguracionDeportistas,{attrs:{"manager":_setup.manager},on:{"guardar":_setup.onGuardarConfiguracion}})],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }